import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { sanitizePlainTextStrict, stripHtmlTags } from '@app/shared/utils';
@AutoUnsubscribe()
@Component({
  selector: 'add-checklist',
  templateUrl: './add-checklist.component.html',
  styleUrls: ['./add-checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddChecklistComponent implements OnInit {
  checklistName = 'Untitled Checklist';

  constructor(private dialogRef: MatDialogRef<AddChecklistComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService) {}

  ngOnInit() {
    if (this.data?.currentChecklistName) {
      const validation = sanitizePlainTextStrict(this.data.currentChecklistName);
      this.checklistName = validation.isValid ? validation.sanitized : 'Untitled Checklist';
    }
  }

  selectAllContent($event) {
    $event.target.select();
  }

  handleInput(event) {
    const raw = event.target.value || '';
    const validation = sanitizePlainTextStrict(raw);
    this.checklistName = validation.isValid ? validation.sanitized : '';
  }

  confirmDialog() {
    const validation = sanitizePlainTextStrict(this.checklistName || '');
    if (!validation.isValid || !validation.sanitized) {
      this.toastr.error(
        this.data?.isSharedVault
          ? 'Please provide a shared vault name'
          : this.data?.isReport
          ? 'Please provide a report name'
          : this.data?.isWorkspace
          ? 'Please provide a workspace name'
          : 'Please provide a Checklist name'
      );
      return;
    }
    const sanitizedName = stripHtmlTags(validation.sanitized).trim();
    if (sanitizedName === '') {
      this.toastr.error(
        this.data?.isSharedVault
          ? 'Please provide a shared vault name'
          : this.data?.isReport
          ? 'Please provide a report name'
          : this.data?.isWorkspace
          ? 'Please provide a workspace name'
          : 'Please provide a Checklist name'
      );
      return;
    }

    if (sanitizedName !== '') {
      this.dialogRef.close({
        confirmation: true,
        checklistName:
          sanitizedName !== 'Untitled Checklist'
            ? sanitizedName
            : this.data?.currentChecklistName
            ? this.data?.currentChecklistName
            : sanitizedName,
      });
    } else {
      this.toastr.error(
        this.data?.isSharedVault
          ? 'Please provide a shared vault name'
          : this.data?.isReport
          ? 'Please provide a report name'
          : this.data?.isWorkspace
          ? 'Please provide a workspace name'
          : 'Please provide a Checklist name'
      );
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  checkIfDisabled() {
    if (this.checklistName.replace(/\s/g, '').length == 0) {
      return true;
    }
  }
}
